<div class="fixed top-5 right-5 z-[9999] flex flex-col gap-2 w-96 max-w-[calc(100vw-40px)] pointer-events-none" aria-live="polite" aria-atomic="false">
  @for (toast of toasts(); track trackById($index, toast)) {
    <div class="relative flex items-start gap-3 p-4 rounded bg-[var(--talos-bg)] pointer-events-auto" style="border:1px solid rgb(var(--talos-ink-rgb) / 0.1)" role="alert">

      <div class="shrink-0 w-8 h-8 rounded flex items-center justify-center"
        [style.background]="toast.type === 'success' ? 'rgb(var(--talos-ink-rgb) / 0.06)' : toast.type === 'error' ? '#fee2e2' : 'rgb(var(--talos-ink-rgb) / 0.04)'"
        [style.color]="toast.type === 'success' ? 'var(--talos-ink)' : toast.type === 'error' ? '#dc2626' : 'var(--talos-ink)'">
        <lucide-icon [img]="iconFor(toast)" [size]="16" color="currentColor" />
      </div>

      <div class="flex-1 min-w-0 pt-0.5">
        <p class="text-sm font-bold text-talos-ink">{{ toast.title }}</p>
        @if (toast.message) {
          <p class="text-xs mt-1 whitespace-pre-line" style="color:rgb(var(--talos-ink-rgb) / 0.5)">{{ toast.message }}</p>
        }
      </div>

      <button class="shrink-0 w-5 h-5 flex items-center justify-center cursor-pointer bg-transparent border-0 transition-colors hover:bg-talos-ink/5" style="color:rgb(var(--talos-ink-rgb) / 0.4)" (click)="toastService.dismiss(toast.id)" aria-label="Dismiss">
        <lucide-icon [img]="XIcon" [size]="13" />
      </button>

    </div>
  }
</div>
